import { useEffect } from "react";
import PageHeader from "../components/PageHeader";
import { DISCLAIMER } from "../data";

const SECTIONS = [
  {
    h: "Acceptance of Terms",
    p: "By accessing JOBLSX or engaging our services, you agree to these Terms of Service. If you do not agree, please discontinue use of our services.",
  },
  {
    h: "Scope of Services",
    p: "JOBLSX provides consulting, account management guidance, profile audits, growth strategy, and technical support. All services are advisory in nature and delivered in good faith based on available information.",
  },
  {
    h: "Client Responsibilities",
    p: "Clients are responsible for implementing recommendations in compliance with the applicable platform's terms and policies. You retain full control and ownership of your accounts.",
  },
  {
    h: "Payments & Scheduling",
    p: "Consultation details, fees (if any), and scheduling are agreed upon prior to service delivery. Rescheduling is accommodated where reasonably possible.",
  },
  {
    h: "Limitation of Liability",
    p: "JOBLSX is not liable for outcomes controlled by third-party platforms, including but not limited to account status, verification, or policy decisions.",
  },
];

export default function Terms() {
  useEffect(() => {
    document.title = "Terms of Service — JOBLSX";
    if (window.location.hash === "#disclaimer") {
      document.getElementById("disclaimer")?.scrollIntoView({ behavior: "smooth" });
    }
  }, []);
  return (
    <div>
      <PageHeader overline="Legal" title="Terms of Service" subtitle="The terms that govern our engagement." />
      <section className="pb-24 pt-8">
        <div className="mx-auto max-w-3xl px-6 md:px-12">
          <div className="space-y-10">
            {SECTIONS.map((s) => (
              <div key={s.h}>
                <h2 className="font-display text-2xl font-medium tracking-tight">{s.h}</h2>
                <p className="mt-3 leading-relaxed text-slate-400">{s.p}</p>
              </div>
            ))}
            <div id="disclaimer" className="scroll-mt-32 rounded-3xl border border-white/10 bg-white/[0.02] p-8">
              <h2 className="font-display text-2xl font-medium tracking-tight">Disclaimer</h2>
              <p className="mt-3 leading-relaxed text-slate-400">{DISCLAIMER}</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
